import React, { useMemo } from 'react';
import { useCallSummary } from '../../store/slices/dashboardSlice';
import ChartComponent from '../../components/charts/ChartComponent';
import { useTranslation } from 'react-i18next';

const AgentCallSummary = () => {
  const { t } = useTranslation();
  const callSummary = useCallSummary();

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : '';
  };

  const barChartData = useMemo(() => {
    const categories = [];
    const answeredCallsData = [];
    const noAnswerCallsData = [];
    const totalCallsData = [];

    callSummary.forEach((item) => {
      categories.push(capitalizeWords(item.call_type));
      answeredCallsData.push(parseInt(item.answered_calls));
      noAnswerCallsData.push(parseInt(item.no_answer_calls));
      totalCallsData.push(parseInt(item.total_calls));
    });

    return {
      options: {
        chart: {
          type: 'bar'
        },
        xaxis: {
          categories
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        }
      },
      series: [
        { name: t('answeredCalls'), data: answeredCallsData },
        { name: t('noAnswerCalls'), data: noAnswerCallsData },
        { name: t('totalCalls'), data: totalCallsData }
      ]
    };
  }, [callSummary]);

  return (
    <ChartComponent
      title={t('agentCallSummary')}
      options={barChartData.options}
      series={barChartData.series}
      height={285}
    />
  );
};

export default AgentCallSummary;
